<template>
    <div>
        <div class="row mb-3">
            <div class="col-4">
                <search-client
                    size="sm"
                    @client-is-set="setClientId"
                    @searching-client="resetClient"
                />
            </div>
        </div>
        <WebDataRocks
            v-if="pivotDisplay"
            :key="key"
            :report="pivotConfig"
            :global="pivotGlobal"
            toolbar
        />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import webDataRocksFrLocalization from '../../../../../../lang/fr/webDataRocksFrLocalization.json'
import WebDataRocks from '../../../common/components/WebDataRocks.vue'
import SearchClient from '../../../activity_management/clients/components/SearchClient.vue'
import config from './billedVsRealPivotConfig.json'

export default {
    name: 'BilledVsRealPivot',

    components: {
        WebDataRocks,
        SearchClient,
    },

    data() {
        return {
            clientIsSet: false,
            client_id: 0,
            pivotDisplay: false,
            pivotConfig: {
                dataSource: {},
                slice: config.slice,
                options: config.options,
                formats: config.formats,
            },

            pivotGlobal: {
                localization: webDataRocksFrLocalization,
            },

            pivotData: null,

            key: 'wrd',
            ready: false,
        }
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
        }),
    },

    methods: {
        showPivot() {
            this.pivotDisplay = true
        },

        hidePivot() {
            this.pivotDisplay = false
        },

        async setClientId(client) {
            this.client_id = client.id
            this.clientIsSet = true
            await this.getData()
            this.showPivot()
            this.updateKey()
        },

        resetClient() {
            this.client_id = 0
            this.clientIsSet = false
            this.hidePivot()
        },

        async updateData() {
            this.hidePivot()
            await this.getData()
            this.showPivot()
            this.updateKey()
        },

        async getData() {
            try {
                const response = await this.$axios.get(
                    `/dashboard/billed-vs-real/pivot/${this.year}/${this.client_id}`
                )
                this.pivotData = response.data.data
                this.setInitialReport()
            } catch (error) {
                console.log(error)
            }
        },

        updateKey() {
            this.key = Date.now()
        },

        setInitialReport() {
            this.ready = false
            this.pivotConfig.dataSource = { data: this.pivotData }

            this.ready = true
            this.key = Date.now()
        },
    },
}
</script>

<style scoped></style>
